import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function FinalCTASection() {
  const scrollToMoney = () => {
    document.getElementById('money-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="py-12 px-5 bg-sage text-white text-center" data-id="element-24">
      <div className="max-w-2xl mx-auto" data-id="element-25">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={{
        visible: {
          transition: {
            staggerChildren: 0.15
          }
        }
      }} data-id="element-26">
          <motion.h2 variants={fadeUp} className="font-serif text-3xl md:text-4xl text-white mb-6" data-id="element-27">
            This is where your life starts changing.
          </motion.h2>

          <motion.div variants={fadeUp} className="space-y-4 text-base text-white mb-8" data-id="element-28">
            <p data-id="element-29">Because once your nervous system stabilizes…</p>
            <p data-id="element-30">Everything else becomes easier.</p>
            <p data-id="element-31">Focus returns. Energy stabilizes. Emotional reactions fade.</p>
            <p data-id="element-32">Not because you fixed yourself…</p>
          </motion.div>

          <motion.div variants={fadeUp} className="bg-white/10 backdrop-blur-sm p-6 rounded-2xl mb-8 border border-white/20" data-id="element-33">
            <p className="font-serif text-xl md:text-2xl text-white" data-id="element-34">
              But because your body stopped fighting you.
            </p>
          </motion.div>

          <motion.div variants={fadeUp} className="space-y-4 text-base text-white mb-8" data-id="element-35">
            <p data-id="element-36">If something in you is recognizing this…</p>
            <p data-id="element-37">Don't ignore it.</p>
            <p data-id="element-38">That quiet feeling of:</p>
            <p className="font-serif text-xl italic mt-2 text-white" data-id="element-39">
              "This is what I've been missing."
            </p>
          </motion.div>

          <motion.div variants={fadeUp} data-id="element-40">
            <motion.button onClick={scrollToMoney} whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.98
          }} className="w-full md:w-auto bg-terracotta hover:bg-terracotta-dark text-white font-semibold text-base md:text-lg py-4 px-10 rounded-full shadow-lg hover:shadow-xl transition-all mb-3" data-id="element-41">
              Reset My Nervous System Now
            </motion.button>
            <p className="text-xs text-white/70 font-medium" data-id="element-42">
              Instant access · One-time secure payment
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}